module.exports = __webpack_public_path__ + "img/animals_monkey.f2877ed6.png";